import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step2_1 from "@/assets/integration-steps/microsoft/step_2_1.png";
import step2_2 from "@/assets/integration-steps/microsoft/step_2_2.png";
import step2_3 from "@/assets/integration-steps/microsoft/step_2_3.png";
import step2_4 from "@/assets/integration-steps/microsoft/step_2_4.png";
import step2_5 from "@/assets/integration-steps/microsoft/step_2_5.png";
import ChannelIntegrationTable from "@/components/channel-integration-table/ChannelIntegrationTable";

interface Props {
  stepLabel?: string;
}

const MicrosoftIntegrationStep2 = ({ stepLabel }: Props) => {
  return (
    <div className="channels-integration-step microsoft-step-2">
      <div className="step-label-row">
        {stepLabel && <OpticksNumberCircle number={stepLabel} />}
        <h6>Create the exclusion audience in Microsoft</h6>
      </div>
      <div className="step-label-row">
        <p>
          First you will need to <b>create an Audience</b>.
        </p>
      </div>
      <p>
        Go to the tools browser, search "Audiences" and in the Audience library
        section start the Audience creation process by clicking on the button "+
        Create".
      </p>

      <img src={step2_1} alt="Screenshot of step 2.1 Microsoft Integration" />
      <img src={step2_2} alt="Screenshot of step 2.2 Microsoft Integration" />

      <hr />

      <p>
        Give a descriptive name to your audience, e.g. "Opticks Negative
        Audience" and select the <b>Remarketing list</b> type.
      </p>
      <img src={step2_3} alt="Screenshot of step 2.3 Microsoft Integration" />

      <hr />

      <p>
        Then select the UET tag from the list and Select the{" "}
        <b>Custom Events</b> option from the selector.
      </p>

      <p>
        Insert the following event values (you can copy them from the table) to
        create Custom events as you can see below:
      </p>

      <ChannelIntegrationTable
        data={[
          {
            category: "Category",
            option: "equals",
            value: "Opticks",
          },
          {
            category: "Action",
            option: "equals",
            value: "OpticksExcludeVisitor",
          },
          {
            category: "Label",
            option: "equals",
            value: "detection",
          },
          {
            category: "Value",
            option: "equal to",
            value: "1",
          },
        ]}
      />

      <img src={step2_4} alt="Screenshot of step 2.4 Microsoft Integration" />

      <hr />

      <p>
        Select a membership duration of <b>75 days</b> and finish the process.
      </p>
      <img src={step2_5} alt="Screenshot of step 2.5 Microsoft Integration" />
    </div>
  );
};

export default MicrosoftIntegrationStep2;
